import React from 'react'

import styles from './styles.module.css'

const RichTextContent = ({ content }) => {
  return <div className={styles['rich-text']} dangerouslySetInnerHTML={{ __html: content }} />
}

export default RichTextContent
